import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { OauthAction, OauthProvider } from 'models/Oauth';

interface State {
  oauthAction: OauthAction | '';
  message: string;
  provider: OauthProvider | '';
}

const initialState: State = {
  oauthAction: '',
  message: '',
  provider: '',
};

const oauthSlice = createSlice({
  name: 'oauth',
  initialState,
  reducers: {
    setOauthAction(state, action: PayloadAction<OauthAction>) {
      state.oauthAction = action.payload;
    },
    setOauthMessage(state, action: PayloadAction<string>) {
      state.message = action.payload;
    },
    setOauthProvider(state, action: PayloadAction<OauthProvider>) {
      state.provider = action.payload;
    },
  },
});

export const selectOauthAction = (state: RootState) => state.oauth.oauthAction;
export const selectOauthMessage = (state: RootState) => state.oauth.message;
export const selectOauthProvider = (state: RootState) => state.oauth.provider;

export const { setOauthAction, setOauthMessage, setOauthProvider } = oauthSlice.actions;
export const reducer = oauthSlice.reducer;
